
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoSupplierDialog extends Serenity.EntityDialog<PoSupplierRow, any> {
        protected getFormKey() { return PoSupplierForm.formKey; }
        protected getIdProperty() { return PoSupplierRow.idProperty; }
        protected getLocalTextPrefix() { return PoSupplierRow.localTextPrefix; }
        protected getNameProperty() { return PoSupplierRow.nameProperty; }
        protected getService() { return PoSupplierService.baseUrl; }
        protected getDeletePermission() { return PoSupplierRow.deletePermission; }
        protected getInsertPermission() { return PoSupplierRow.insertPermission; }
        protected getUpdatePermission() { return PoSupplierRow.updatePermission; }

        protected form = new PoSupplierForm(this.idPrefix);

        constructor() {
            super();

            // this.form.ConsignFg.element.parent();
            this.form.ConsignFg.change(e => {
                var isConsignFgT = this.ConsignFgT;
                var isConsignFgF = this.ConsignFgF;


                if (!isConsignFgT) {
                    Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, isConsignFgT);
                    return this.form.ConsignGp.value = 0;

                }
                else if (!isConsignFgF) {
                    Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, !isConsignFgF);


                }
            });

            this.form.PurVatType.change(e => {
                var isVatTypeN = this.VatTypeN;
                var isVatTypeV = this.VatTypeV;


                if (!isVatTypeN) {
                    Serenity.EditorUtils.setReadOnly(this.form.PurVatCode, !isVatTypeN);
                    return this.form.PurVatCode.value = "N";

                }
                else if (!isVatTypeV) {
                    Serenity.EditorUtils.setReadOnly(this.form.PurVatCode, isVatTypeV);
                    return this.form.PurVatCode.value = "V7";

                }
            });
        }
        private get VatTypeN() {
            return this.form.PurVatType.value != "N";
        }
        private get VatTypeV() {
            return this.form.PurVatType.value != "V";
        }

        private get ConsignFgT() {
            return this.form.ConsignFg.value != true;
        }
        private get ConsignFgF() {
            return this.form.ConsignFg.value != false;
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();


            this.syscuscheck();




        }

        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 29 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.PayMethod.getGridField().toggle(true);

            } else {
                this.form.PayMethod.getGridField().toggle(false);

            }
            var Supplierid = Q.tryFirst(Product.CsSkuRow.getLookup().items, x => x.SupplierId == this.entity.SupplId);
            if (Supplierid != null) {
                this.deleteButton.toggleClass('disabled', true);

            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

    }
}